import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AddressComponent } from '../address/address.component';
import { AssociationLevelComponent } from '../association-level/association-level.component';
import { CompleteComponent } from '../complete/complete.component';
import { ContactInfoComponent } from '../contact-info/contact-info.component';
import { EmailComponent } from '../email/email.component';
import { IndividualAffiliationsComponent } from '../individual-affiliations/individual-affiliations.component';
import { LoginComponent } from '../login/login.component';
import { ProspectDemographicsComponent } from '../prospect-demographics/prospect-demographics.component';
import { ReferralComponent } from '../referral/referral.component';
import { WizardGuardService } from '../wizard-guard.service';
import { RedirectComponent } from './../redirect/redirect.component';

export const appRoutes: Routes = [
  { path: 'signup/referral', redirectTo: 'signup/email' },
  { path: 'signup', redirectTo: 'signup/email', pathMatch: 'full' },
  { path: 'join', redirectTo: 'signup/email', pathMatch: 'full' },
  { path: 'members/renew', component: RedirectComponent },
  { path: 'signup/email', component: EmailComponent, canActivate: [WizardGuardService] },
  { path: 'signup/update', component: ContactInfoComponent, canActivate: [WizardGuardService], data: { noSkip: true } },
  { path: 'signup/contact', component: ContactInfoComponent, canActivate: [WizardGuardService] },
  { path: 'signup/address', component: AddressComponent, canActivate: [WizardGuardService] },
  { path: 'signup/affiliations', component: IndividualAffiliationsComponent, canActivate: [WizardGuardService] },
  { path: 'signup/demographics', component: ProspectDemographicsComponent, canActivate: [WizardGuardService] },
  { path: 'signup/referral/:cst_recno', component: ReferralComponent, canActivate: [WizardGuardService] },
  { path: 'signup/complete', component: CompleteComponent, canActivate: [WizardGuardService] },
  { path: 'members/eWeb/PACMemApp', redirectTo: 'signup/selection' },
  { path: 'signup/login', component: LoginComponent, canActivate: [WizardGuardService] },
  { path: 'signup/AffinityPortal', component: EmailComponent, canActivate: [WizardGuardService] },
  {
    path: 'signup/AffinityPortal/:affinity',
    loadChildren: () => import('../affinity-portal/affinity-portal.module').then(m => m.AffinityPortalModule),
    canActivate: [WizardGuardService],
    canActivateChild: [WizardGuardService]
  },
  {
    path: 'signup/AffinityPortal/:affinity/location/:location/monthly-payments',
    loadChildren: () => import('../monthly-payment/monthly-payment.module').then(m => m.MonthlyPaymentModule),
    canActivate: [WizardGuardService],
    canActivateChild: [WizardGuardService]
  },
  { path: 'signup/ec-plus', component: AssociationLevelComponent, canActivate: [WizardGuardService], data: { ecPlus: true } },
  { path: 'signup/free-month-extension', component: AssociationLevelComponent, canActivate: [WizardGuardService], data: { freeAssociate: true } },
  {
    path: 'signup/selection',
    canActivate: [WizardGuardService],
    loadChildren: () => import('../association-level/association-level.module').then(m => m.AssociationLevelModule)
  },
  {
    path: 'signup/checkout',
    canActivate: [WizardGuardService],
    loadChildren: () => import('../checkout/checkout.module').then(m => m.CheckoutModule)
  },
  {
    path: 'members/certified-central',
    canActivate: [WizardGuardService],
    loadChildren: () => import('../certified-upgrade/certified-upgrade.module').then(m => m.CertifiedUpgradeModule)
  },
  { path: 'signup/student', loadChildren: () => import('../student-portal/student-portal.module').then(m => m.StudentPortalModule) },
  { path: '**', redirectTo: 'signup/email' }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, {
    anchorScrolling: 'enabled',
    onSameUrlNavigation: 'reload',
    relativeLinkResolution: 'legacy'
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
